/**
 * Asterisco vermelho de "campo obrigatório" — padrão usual que todo mundo
 * entende. Use ao lado do label de qualquer campo obrigatório (onboarding,
 * tarefas, escala). Combina com o bloqueio de avanço + mensagem clara quando a
 * pessoa tenta prosseguir sem preencher.
 */
export function RequiredMark({ label }: { label?: string }) {
  return (
    <span
      title="Campo obrigatório"
      aria-label="obrigatório"
      style={{ color: "#e5484d", fontWeight: 700, marginLeft: 3, whiteSpace: "nowrap" }}
    >
      *
      {label ? (
        <span style={{ fontSize: 11, fontWeight: 600, marginLeft: 4, letterSpacing: 0 }}>{label}</span>
      ) : null}
    </span>
  );
}
